var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body main-font"},[_c('div',{staticClass:"shop-items"},[_c('nft-list',{attrs:{"isShop":true,"nftIdTypes":_vm.itemRender,"isLoading":_vm.isLoading}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }